

































































































import { AdgroupFormData, CampaignFormData, IOS14QuotaType } from '@tt4b/ttam-enums';
import { useAdgroupIos14 } from '@tt4b/ttam-hooks';
import { computed, defineComponent, onMounted, PropType, ref, toRefs } from '@vue/composition-api';
import Audience from './index';

const name = 'ttam-audience-sales-retarget';
export default defineComponent({
  name,
  components: {
    TtamAudienceAddedViewedSelect: Audience.TtamAudienceAddedViewedSelect,
    TtamAudienceCustomActions: Audience.TtamAudienceCustomActions,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup(props, { emit }) {
    const { adgroupData, campaignData } = toRefs(props);
    const { isDedicateCampaign } = useAdgroupIos14({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const _salesRetarget = computed({
      get: () => adgroupData.value.dpaRetargetingType,
      set: val => {
        emit('dpa-retargeting-type-change', val);
      },
    });
    // Initial select value set to 30 days.
    const defaultSelectDays = 30;
    const storedViewedSelect = ref(defaultSelectDays);
    const storedAddedSelect = ref(defaultSelectDays);
    // Viewed or added to cart but not purchased
    const viewedSelect = computed(() => {
      if (_salesRetarget.value === 1 && adgroupData.value.includeCustomActions.length !== 0) {
        return adgroupData.value.includeCustomActions[0].days;
      }
      return defaultSelectDays;
    });
    // Added to cart but not purchased
    const addedSelect = computed(() => {
      if (adgroupData.value.dpaRetargetingType === 2 && adgroupData.value.includeCustomActions.length !== 0) {
        return adgroupData.value.includeCustomActions[0].days;
      }
      return defaultSelectDays;
    });
    // custom
    const includeCustomActions = ref([{ code: 4002, days: defaultSelectDays }]);
    const excludeCustomActions = ref([]);
    const includeCustomActionsRef = ref();
    const excludeCustomActionsRef = ref();

    const { viewedValidator, addedValidator, includeAndExcludeValidator } = Audience.useAudienceRetargetRule({
      viewedSelect,
      addedSelect,
      includeCustomActions,
      excludeCustomActions,
    });
    const setViewedSelect = val => {
      if (val) {
        let includeArr = [
          { days: val, code: 4002 },
          { days: val, code: 4003 },
        ];
        let excludeArr = [{ days: val, code: 4006 }];
        emit('include-custom-actions-change', includeArr);
        emit('exclude-custom-actions-change', excludeArr);
      }
    };
    const setAddedSelect = val => {
      if (val) {
        let includeArr = [{ days: val, code: 4003 }];
        let excludeArr = [{ days: val, code: 4006 }];
        emit('include-custom-actions-change', includeArr);
        emit('exclude-custom-actions-change', excludeArr);
      }
    };
    const validateActionForm = () => {
      includeCustomActionsRef.value.validate('custom');
      excludeCustomActionsRef.value.validate('custom');
    };
    const setIncludeCustomActions = (arr: { code: number; days: number }[]) => {
      let filterIncludeArr = arr.filter(item => item.days);
      validateActionForm();
      if (filterIncludeArr.length >= 0) {
        emit('include-custom-actions-change', filterIncludeArr);
      }
    };
    const setExcludeCustomActions = (arr: { code: number; days: number }[]) => {
      let filterExcludeArr = arr.filter(item => item.days);
      validateActionForm();
      if (filterExcludeArr.length >= 0) {
        emit('exclude-custom-actions-change', filterExcludeArr);
      }
    };
    const addInclude = () => {
      const includeArr = [...includeCustomActions.value];
      includeArr.push({
        code: 4002,
        days: undefined,
      });
      includeCustomActions.value = includeArr;
    };
    const addExclude = () => {
      const excludeArr = [...excludeCustomActions.value];
      excludeArr.push({
        code: 4002,
        days: undefined,
      });
      excludeCustomActions.value = excludeArr;
    };
    const deleteInclude = index => {
      // 至少保留一个
      if (includeCustomActions.value.length > 1) {
        let includeArr = [...includeCustomActions.value];
        includeArr.splice(index, 1);
        includeCustomActions.value = includeArr;
        setIncludeCustomActions(includeArr);
      }
    };
    const deleteExclude = index => {
      let excludeArr = [...excludeCustomActions.value];
      excludeArr.splice(index, 1);
      excludeCustomActions.value = excludeArr;
      setExcludeCustomActions(excludeArr);
    };
    const onIncludeActionsChange = (val, index, type) => {
      let includeArr = [...includeCustomActions.value];
      includeArr[index][type] = val;
      includeCustomActions.value = includeArr;
      setIncludeCustomActions(includeArr);
    };
    const onExcludeActionsChange = (val, index, type) => {
      let excludeArr = [...excludeCustomActions.value];
      excludeArr[index][type] = val;
      excludeCustomActions.value = excludeArr;
      setExcludeCustomActions(excludeArr);
    };
    const changeRetargetValue = val => {
      if (val === 1) {
        setViewedSelect(storedViewedSelect.value);
      } else if (val === 2) {
        setAddedSelect(storedAddedSelect.value);
      } else {
        setIncludeCustomActions(includeCustomActions.value);
        setExcludeCustomActions(excludeCustomActions.value);
      }
    };
    const onViewedSelectChange = val => {
      storedViewedSelect.value = val;
      setViewedSelect(val);
    };
    const onAddedSelectChange = val => {
      storedAddedSelect.value = val;
      setAddedSelect(val);
    };

    const initDataFromAdgroupData = () => {
      const {
        dpaRetargetingType,
        includeCustomActions: includeActions,
        excludeCustomActions: excludeActions,
      } = adgroupData.value;
      if (dpaRetargetingType === 3) {
        includeCustomActions.value = includeActions.length ? includeActions : includeCustomActions.value;
        excludeCustomActions.value = excludeActions.length ? excludeActions : excludeCustomActions.value;
      }
    };

    onMounted(() => {
      initDataFromAdgroupData();
    });

    return {
      name,
      _salesRetarget,
      isDedicateCampaign,
      includeCustomActions,
      excludeCustomActions,
      includeCustomActionsRef,
      excludeCustomActionsRef,
      viewedSelect,
      viewedValidator,
      addedSelect,
      addedValidator,
      includeAndExcludeValidator,
      changeRetargetValue,
      onViewedSelectChange,
      onAddedSelectChange,
      addExclude,
      addInclude,
      deleteExclude,
      deleteInclude,
      onIncludeActionsChange,
      onExcludeActionsChange,
    };
  },
});
